import React from 'react';
import PropTypes from 'prop-types';
import { decodeHTML, encodeHTML } from 'entities';
import sanitizeHTML from 'sanitize-html';

import omit from 'lodash/omit';
import Input from '../Input';

const removeMarkup = (html) => sanitizeHTML(html, {
  allowedTags: [],
  textFilter: (text) => decodeHTML(text), // need to decode so that when it's displayed in text box it does not have markup.
});

export default class InputRestictMarkup extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.string,
  };

  onInputChange = (e) => {
    const { onChange } = this.props;
    const { value, name } = e.target;
    if (onChange) {
      onChange({ target: { name, value: encodeHTML(value) } });
    }
  };

  render() {
    const { value, ...rest } = this.props;
    const passthroughProps = omit(rest, 'onChange');
    return (
      <Input
        value={removeMarkup(value)}
        {...passthroughProps}
        onChange={this.onInputChange}
      />
    );
  }
}
